import styles from './index.module.sass';
import { useLocation, useHistory } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import iconClose from 'assets/icon_close_round.svg';
import { distributorName } from 'config';
import { config } from 'config';
import { useAppContext } from 'use-app';
import { isNpcpay, isCitimkt, isCpcpay, isIknow99 } from 'config';

const Contact = () => {
  const history = useHistory();
  const location = useLocation();
  const iframeRef = useRef('');
  const [postFormSuccess, setPostFormSuccess] = useState(false);
  const { state: appState } = useAppContext();

  useEffect(() => {
    const receiveMessage = e => {
      if (e.origin === config.contactFormUrl) {
        const { success } = e.data;
        if (success) setPostFormSuccess(true);
      }
    };

    window.addEventListener('message', receiveMessage, false);
    return () => {
      window.removeEventListener('message', receiveMessage);
    };
  }, []);

  useEffect(() => {
    const beforeUnloadListener = event => {
      if (isCpcpay || isCitimkt || isIknow99 || isNpcpay) return;
      event.preventDefault();
      if (!postFormSuccess) return (event.returnValue = '是否確認離開客服表單？重新進入將會清除已輸入內容。');
    };

    window.addEventListener('beforeunload', beforeUnloadListener);

    return () => {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    };
  }, [postFormSuccess]);

  useEffect(() => {
    if (isCpcpay || isCitimkt || isIknow99 || isNpcpay) return;

    const unblock = history.block(() => {
      if (location.state?.from && !postFormSuccess) {
        return window.confirm('是否確認離開客服表單？重新進入將會清除已輸入內容。');
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [postFormSuccess]); // eslint-disable-line

  const onBack = () => {
    if (location.state?.from) {
      history.push(location.state.from);
    } else {
      history.goBack();
    }
  };

  let params = {
    userId: appState.me?.id,
    name: appState.me?.displayName,
    mobile: appState.me?.mobile,
    email: appState.me?.email,
    poi: location.state?.poi,
    orderId: location.state?.orderId,
    plateNumber: location.state?.plateNumber,
    issueGroupKey: location.state?.issueGroupKey,
    issueKey: location.state?.issueKey,
    distributorName: distributorName(),
    distributorId: config.distributorUid,
    fromIframe: true,
  };

  let paramsToString = () => {
    let newParams = Object.fromEntries(Object.entries(params).filter(([_, value]) => value));
    return new URLSearchParams(newParams).toString();
  };

  return (
    <div className={styles.contact}>
      <div className={styles.close} onClick={onBack}>
        <img src={iconClose} alt="close" />
      </div>
      <iframe
        ref={iframeRef}
        src={`${config.contactFormUrl}/?${paramsToString()}`}
        // src={`https://localhost:4200/?${paramsToString()}`} //測試用
        title="聯絡我們"
      />
    </div>
  );
};

export default Contact;
